// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
// import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import {
    getCurrencies,
    getFulfillmentLabel,
    getIsPunchOutSession,
    getLanguages,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setCurrency from "@insite/client-framework/Store/Context/Handlers/SetCurrency";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import removeCart from "@insite/client-framework/Store/Data/Carts/Handlers/RemoveCart";
import { getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByPageType, LinkModel, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu"; // Starter Custom Code
import ShowInventoryToggle, { ShowInventoryToggleStyles } from "@insite/content-library/Components/ShowInventoryToggle";
import ShowPricingToggle, { ShowPricingToggleStyles } from "@insite/content-library/Components/ShowPricingToggle";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
// import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Icon, { IconProps } from "@insite/mobius/Icon"; // Store Custom Code
import Globe from "@insite/mobius/Icons/Globe";
import MapPin from "@insite/mobius/Icons/MapPin";
// import Menu from "@insite/mobius/Icons/Menu"; // Starter Custom Code
import { MappedLink } from "@insite/mobius/Menu";
// import PanelMenu, { PanelMenuPresentationProps } from "@insite/mobius/PanelMenu"; // Starter Custom Code
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import omitSingle from "@insite/mobius/utilities/omitSingle";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import AccountMessagesCount, {
    AccountMessagesCountPresentationProps,
} from "@store/Library/Components/Toolkit/AccountMessagesCount";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import CubeFill from "@store/Library/Components/Toolkit/Icons/Cube/CubeFill";
import Menu from "@store/Library/Components/Toolkit/Icons/Menu";
import PersonFill from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
import SettingsLine from "@store/Library/Components/Toolkit/Icons/Settings/SettingsLine";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import PanelMenu, { PanelMenuPresentationProps } from "@store/MobiusOverrides/PanelMenu/PanelMenu";
import NavigationModeMenu, { NavigationModeCookieName } from "@store/Overrides/Components/NavigationModeMenu";
import { headerLinkListIcons } from "@store/Overrides/Widgets/Header/HeaderLinkList";
// import { menuPanelContentRowStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu"; // Store Custom Code
import { formGridProps } from "@store/Themes/common/props/form";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
// import { menuPanelProps } from "@store/Themes/common/props/menu"; // Store Custom Code
import useIsDuplicate from "@toolkit/Framework/Common/Hooks/useIsDuplicate";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { LinkModelWithIcon } from "@toolkit/Framework/Store/Links/LinksSelectors";
import { iconColorStyles, iconOffsetStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import Icon, { IconProps, IconWrapper } from "@insite/mobius/Icon";
import useUniquePageLinks from "@store/Framework/Common/Hooks/useUniquePageLinks";
import { useIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosHooks";
import ArrowForward, { ArrowForwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import GlobeLine from "@store/Library/Components/Toolkit/Icons/Globe/GlobeLine";
import { visualizerMenuIcon, visualizerMenuOnClick } from "@store/Library/Widgets/Common/VisualizerMenu";
import { WebsiteMenuLinkModel } from "@store/Library/Widgets/Common/WebsiteMenu";
import { menuPanelContentRowStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { menuDrawerProps as menuPanelProps } from "@store/Themes/common/props/menu";
/* Store Custom Code - End */

export interface NavigationDrawerIconPreset {
    size?: string;
    offset?: string;
    spacing?: string;
}

export const navigationDrawerIconPresets: Dictionary<NavigationDrawerIconPreset> = {
    default: {
        size: pxToRem(24), // Store Custom Code
        offset: pxToRem(2),
        spacing: pxToRem(7), // Store Custom Code
    },
    large: {
        size: pxToRem(32),
        offset: pxToRem(4),
        spacing: pxToRem(14),
    },
};

export type NavigationDrawerIconPresetType = keyof typeof navigationDrawerIconPresets;
const iconDefault = navigationDrawerIconPresets["default"];
const iconLarge = navigationDrawerIconPresets["large"];
const languageIconSize = pxToRem(18);

const getIconProps = (
    src?: IconProps["src"],
    size?: string | null,
    preset: NavigationDrawerIconPresetType = "default",
): IconProps => {
    const _preset = navigationDrawerIconPresets[preset];
    const _size = size || _preset.size;

    return {
        src,
        css: css`
            ${iconScalableStyles(_size, false)}
            ${iconOffsetStyles(_preset.offset, _preset.spacing)}
            ${_size !== _preset.size ? `width: ${_preset.size};` : null}
            justify-content: center;
        `,
    };
};

const panelSectionWrapperStyles = () => css`
    display: flex;
    align-items: center;
`;
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    /* Starter Custom Code - Start */
    const { isAuthenticated, isGuest, firstName, lastName, userName } = getSession(state);
    const targetZone = ["Left", "Right"];

    const secondaryNavWidgets = getWidgetsByPageId(state, getHeader(state).id)
        .filter((widget: WidgetProps) => targetZone.includes(widget.zone))
        .sort((a, b) => targetZone.indexOf(a.zone) - targetZone.indexOf(b.zone));

    const settingsMenu = secondaryNavWidgets.find(x => x.type === "Common/SettingsMenu");
    const currencyMenu = secondaryNavWidgets.find(x => x.type === "Common/CurrencyMenu");
    const languageMenu = secondaryNavWidgets.find(x => x.type === "Common/LanguageMenu");
    /* Store Custom Code - Start */
    const visualizerMenu = secondaryNavWidgets.find(x => x.type === "Common/VisualizerMenu");
    const websiteMenuLinksFields = secondaryNavWidgets
        .filter((widget: WidgetProps) => widget.type === "Common/WebsiteMenu")
        .reduce((y, x) => y.concat(x.fields.links), [] as WebsiteMenuLinkModel[]);
    const websiteMenuWidget = secondaryNavWidgets.find(x => x.type === "Common/WebsiteMenu");
    const websiteMenuModalConfig = websiteMenuWidget
        ? {
              showSwitchModal: Boolean(websiteMenuWidget.fields.showSwitchModal),
              modalHeadline: websiteMenuWidget.fields.modalHeadline as string,
              modalBody: websiteMenuWidget.fields.modalBody as string,
              modalCtaLabel: websiteMenuWidget.fields.modalCtaLabel as string,
              modalCancelLabel: websiteMenuWidget.fields.modalCancelLabel as string,
          }
        : {
              showSwitchModal: false,
              modalHeadline: "",
              modalBody: "",
              modalCtaLabel: "",
              modalCancelLabel: "",
          };
    /* Store Custom Code - End */

    const headerLinkListLinkFields = secondaryNavWidgets
        .filter((widget: WidgetProps) => widget.type === "Header/HeaderLinkList")
        .reduce((y, x) => y.concat(x.fields.links), [] as LinkModelWithIcon[]);
    /* Starter Custom Code - End */
    const displayPricingAndInventory = state.context.session?.displayPricingAndInventory || false;
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const displayPricingAndInventoryToggles = displayPricingAndInventory && currentMode === "Storefront"; // Starter Custom Code

    return {
        currencies: getCurrencies(state),
        currentCurrencyId: state.context.session.currency?.id,
        currentCurrencySymbol: state.context.session.currency?.currencySymbol,
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        currentLocation: getLocation(state),
        userName: state.context.session?.userName,
        isGuest: state.context.session?.isGuest,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage"),
        vmiDashboardPageUrl: getPageLinkByPageType(state, "VmiDashboardPage")?.url,
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
        headerLinkListLinkFields,
        showCustomerMenuItem: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        fulfillmentLabel: getFulfillmentLabel(state),
        navDrawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
        flyoutDrawerIsOpen: state.components.addressDrawer.flyoutDrawerIsOpen,
        isPunchOutSession: getIsPunchOutSession(state),
        cart: getCurrentCartState(state).value,
        visibilityState: findVisibilityState(state.data.pages.widgetsById),
        displayPricingAndInventoryToggles, // Starter Custom Code
        // Starter Custom Code
        fulfillmentMethod: state.components.addressDrawer.fulfillmentMethod,
        showAddressesSelector: isAuthenticated && !isGuest,
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        showCurrencyMenu: Boolean(currencyMenu),
        showCurrencyIcon: Boolean(currencyMenu?.fields.showIcon),
        showLanguageMenu: Boolean(languageMenu),
        showLanguageIcon: Boolean(languageMenu?.fields.showIcon),
        showSettingsMenu: Boolean(settingsMenu),
        showSettingsIcon: Boolean(settingsMenu?.fields.showIcon),
        showInventoryToggle: Boolean(settingsMenu?.fields.showInventoryToggle) && displayPricingAndInventoryToggles,
        showPricingToggle: Boolean(settingsMenu?.fields.showPricingToggle) && displayPricingAndInventoryToggles,
        // Store Custom Code
        showVisualizerMenu: Boolean(visualizerMenu) && getSettingsCollection(state).customSettings?.enableVisualizer,
        showVisualizerIcon: Boolean(visualizerMenu?.fields.showIcon),
        visualizerMenuTitle: visualizerMenu?.fields.title,
        websiteMenuLinksFields,
        websiteMenuModalConfig,
    };
};

const mapDispatchToProps = {
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
};

interface OwnProps {
    links: MappedLink[];
    showQuickOrder: boolean;
    quickOrderLink: PageLinkModel | undefined;
    displayVmiNavigation?: boolean;
    vmiPageLinks?: (PageLinkModel | undefined)[];
    displayModeSwitch?: boolean;
    currentMode?: string;
    isCompactHeaderFlyout?: boolean;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    rootElementSelector?: string;
    allowOpenParentLinks?: boolean;
    // Starter Custom Code
    uniqueId?: string;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

export interface NavigationDrawerStyles {
    menuTriggerButton?: ButtonPresentationProps;
    drawer?: DrawerPresentationProps;
    drawerSectionWrapper?: InjectableCss;
    currencySelectorWrapper?: InjectableCss;
    languageSelectorWrapper?: InjectableCss;
    panelMenu?: PanelMenuPresentationProps;
    panelSectionWrapper?: InjectableCss;
    menuRowIcon?: IconProps;
    userRowTypography?: TypographyPresentationProps;
    punchOutUserRowText?: TypographyPresentationProps;
    mainNavigationRow?: PanelRowPresentationProps;
    mainNavigationRowIcon?: IconProps;
    punchOutNavigationRowIcon?: IconProps;
    mainNavigationRowTypography?: TypographyPresentationProps;
    logoLinks?: PanelRowPresentationProps & { typographyProps?: TypographyPresentationProps }; // Starter Custom Code
    currencySymbol?: TypographyPresentationProps;
    changeCustomerRow?: PanelRowPresentationProps;
    changeCustomerRowContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
    showInventoryToggle?: ShowInventoryToggleStyles;
    showPricingToggle?: ShowPricingToggleStyles;
    signOutRow?: PanelRowPresentationProps;
    signOutRowText?: TypographyPresentationProps;
    // Starter Custom Code
    drawerSecondarySectionWrapper?: InjectableCss;
    largePanelSectionWrapper?: InjectableCss;
    largeRow?: PanelRowPresentationProps;
    largeRowWrapper?: InjectableCss;
    largeRowTitle?: TypographyPresentationProps;
    largeRowText?: TypographyPresentationProps;
    accountIcon?: IconProps;
    fulfillmentIcon?: IconProps;
    languageIcon?: IconProps;
    fulfillmentRow?: PanelRowPresentationProps;
    fulfillmentRowText?: TypographyPresentationProps;
    settingsRow?: PanelRowPresentationProps;
    settingWrapper?: InjectableCss;
    mainNavigationWrapper?: InjectableCss;
    contentPanelMenu?: PanelMenuPresentationProps;
    accountMessagesCountStyles?: AccountMessagesCountPresentationProps;
    buttonAccountMessagesCountStyles?: AccountMessagesCountPresentationProps;
    // Store Custom Code
    largeRowsWrapper?: InjectableCss;
    websiteSelectorWrapper?: InjectableCss;
    websiteIcon?: IconProps;
}

const StyledSection = getStyledWrapper("section");
const StyledSpan = getStyledWrapper("span");

export const navigationDrawerStyles: NavigationDrawerStyles = {
    menuTriggerButton: mergeProps<NavigationDrawerStyles["menuTriggerButton"]>(headerIconButtonProps, {
        css: css`
            position: relative;
        `,
    }),
    drawer: {
        cssOverrides: {
            drawerBody: menuPanelProps.wrapperCss,
            drawerTitle: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeButtonIconProps: menuPanelProps.closeButtonIcon,
    },
    panelSectionWrapper: {
        css: panelSectionWrapperStyles(),
    },
    largePanelSectionWrapper: {
        css: css`
            ${panelSectionWrapperStyles()}
            overflow: hidden;
            width: 100%;
        `,
    },
    /* Store Custom Code - Start */
    largeRowsWrapper: {
        css: css`
            margin: ${pxToRem(8, 0)};
        `,
    },
    /* Store Custom Code - End */
    largeRow: {
        css: css`
            ${x => x.theme.panelMenu.defaultProps?.panelRowProps?.css}
            position: relative;
            /* Store Removed - border-color */
            padding-top: ${pxToRem(6) /* Store Custom Code */};
            padding-bottom: ${pxToRem(6) /* Store Custom Code */};
            /* Store Custom Code - Start */
            font-size: ${x => x.theme.design.typography.size.smaller};
            border: 0;
            /* Store Custom Code - End */
        `,
    },
    largeRowWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;
            min-height: ${iconLarge.size};
            position: relative;
            width: 100%;
        `,
    },
    largeRowTitle: {
        ellipsis: true,
        css: css`
            display: block;
            float: left; /* Prevent underline */
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    largeRowText: {
        ellipsis: true,
        css: css`
            display: block;
        `,
    },
    mainNavigationWrapper: {
        /* Store Custom Code - Start */
        css: css`
            ${menuPanelProps.menuCss}
            background-color: ${getColor("common.accent")};
        `,
        /* Store Custom Code - End */
    },
    mainNavigationRow: {
        css: css`
            ${x => x.theme.panelMenu.defaultProps?.panelRowProps?.css};
            /* Store Removed - text-transform */
            /* Store Custom Code - Start */
            font-family: ${x => x.theme.design.typography.fontFamily.title};

            &:hover,
            &:active {
                color: ${getColor("menu.mainNavigation.hover")};
                text-decoration: none;

                ${IconWrapper} {
                    color: inherit;
                }
            }
            /* Store Custom Code - End */
        `,
        /* Store Custom Code - Start */
        isCurrentCss: css`
            ${x => x.theme.panelMenu.defaultProps?.panelRowProps?.isCurrentCss};
            color: ${getColor("menu.mainNavigation.hover")};
            text-decoration: none;
        `,
        /* Store Custom Code - End */
    },
    accountIcon: getIconProps(PersonFill, null), // Store Custom Code
    fulfillmentIcon: getIconProps(CubeFill, null), // Store Custom Code
    drawerSecondarySectionWrapper: {
        css: css`
            background-color: ${getColor("primary") /* Store Custom Code */};
            color: ${getColor("primary.contrast") /* Store Custom Code */};
            padding-top: ${pxToRem(10)};

            .secondary-row-icon {
                ${iconColorStyles("inherit")}
            }

            .drawer-secondary-section-wrapper + & {
                padding-top: 0;
            }

            &:last-child {
                flex: 1 0 auto;
                padding-bottom: ${pxToRem(10)};
            }
        `,
    },
    logoLinks: {
        css: css`
            ${menuPanelRowStyles({
                iconPosition: "right",
                color: "inherit",
                hoverColor: "primary.contrast", // Store Custom Code
                accentColor: null,
                accentHoverColor: null,
                // Store Custom Code
                iconOffset: ArrowForwardOffset,
            })}

            padding-top: ${pxToRem(12)};
            padding-bottom: ${pxToRem(12)};
            border: none;
            /* Store Custom Code - Start */
            font-size: ${x => x.theme.design.typography.size.smaller};

            &.website-selector {
                font-size: ${x => x.theme.design.typography.size.smallest};
                letter-spacing: 0.2em;

                + [class^="PanelChildren"] [class^="PanelMenuStyle"] {
                    letter-spacing: 0.2em;
                }
            }
            /* Store Custom Code - End */
        `,
        isCurrentCss: css`
            background-color: transparent;
            text-decoration: underline;
            color: ${getColor("primary.contrast") /* Store Custom Code */};
        `,
        /* Store Custom Code - Start */
        moreIconProps: { src: ArrowForward },
        /* Store Custom Code - End */
    },
    currencySymbol: {
        color: "inherit",
        css: css`
            ${iconOffsetStyles(iconDefault.offset, iconDefault.spacing)}
            float: left;
            width: ${iconDefault.size};
            font-size: ${iconDefault.size};
            font-weight: ${x => x.theme.design.typography.weight.base};
            height: 0;
            line-height: 0;
            text-align: center;
            cursor: default;
            pointer-events: none;
            user-select: none;
        `,
    },
    languageIcon: getIconProps(Globe, languageIconSize),
    contentPanelMenu: {
        cssOverrides: {
            menu: css`
                padding: 0;
            `,
        },
    },
    changeCustomerRow: {
        css: menuPanelContentRowStyles(),
    },
    changeCustomerRowContainer: formGridProps.gridContainer,
    fulfillmentMethodGridItem: { width: 12 },
    addressesGridItem: { width: 12 },
    pickUpAddressGridItem: { width: 12 },
    settingsRow: {
        css: menuPanelContentRowStyles(),
    },
    settingWrapper: {
        css: css`
            display: flex;

            &:not(:first-child) {
                padding-top: ${pxToRem(12)};
                margin-top: ${pxToRem(12)};
                border-top: 1px solid ${getColor("common.border")};
            }
        `,
    },
    /* Starter Custom Code - Start */
    accountMessagesCountStyles: {
        position: pxToRemArray([6, null, null, 27]), // Store Custom Code
    },
    buttonAccountMessagesCountStyles: {
        position: pxToRemArray([2, 0, 0, 25]),
        extendedStyles: {
            messagesCountText: {
                css: css`
                    &&& {
                        font-size: ${pxToRem(10)};
                        font-weight: ${x => x.theme.design.typography.weight.bold};
                        padding-top: ${pxToRem(2)};
                    }
                `,
            },
        },
    },
    /* Starter Custom Code - End */
    /* Store Custom Code - Start */
    websiteIcon: getIconProps(GlobeLine),
    /* Store Custom Code - End */
};

const styles = navigationDrawerStyles;

const NavigationDrawer = ({
    links,
    showQuickOrder,
    quickOrderLink,
    displayVmiNavigation,
    vmiPageLinks,
    displayModeSwitch,
    currentMode,
    isCompactHeaderFlyout,
    showFlyoutPricingToggle,
    showFlyoutInventoryToggle,
    rootElementSelector,
    currencies,
    currentCurrencyId,
    currentCurrencySymbol,
    languages,
    currentLanguage,
    currentLocation,
    userName,
    isGuest,
    myAccountPageLink,
    signInUrl,
    vmiDashboardPageUrl,
    homePageUrl,
    headerLinkListLinkFields,
    showCustomerMenuItem,
    fulfillmentLabel,
    navDrawerIsOpen,
    flyoutDrawerIsOpen,
    isPunchOutSession,
    cart,
    history,
    theme,
    displayPricingAndInventoryToggles,
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
    visibilityState,
    allowOpenParentLinks,
    // Starter Custom Code
    fulfillmentMethod,
    showAddressesSelector,
    userDisplayName,
    uniqueId,
    showCurrencyMenu,
    showCurrencyIcon,
    showLanguageMenu,
    showLanguageIcon,
    showSettingsMenu,
    showSettingsIcon,
    showInventoryToggle,
    showPricingToggle,
    // Store Custom Code
    showVisualizerMenu,
    showVisualizerIcon,
    visualizerMenuTitle,
    websiteMenuLinksFields,
    websiteMenuModalConfig,
}: Props) => {
    /* Starter Custom Code - Start */
    if (useIsDuplicate("NavigationDrawer", uniqueId)) {
        return null;
    }

    /* Store Custom Code - Start */
    const [isSwitchModalOpen, setIsSwitchModalOpen] = React.useState(false);
    const [pendingHref, setPendingHref] = React.useState<string | null>(null);
    const [pendingTitle, setPendingTitle] = React.useState<string>("");
    const [pendingTarget, setPendingTarget] = React.useState<"_self" | "_blank">("_self");
    const isB2BCustomer = useIsB2BCustomer();

    const websiteMenuOptions: MappedLink[] = [];
    let websiteMenuCurrentOption = "";
    const { links: websiteMenuLinks, hasMissingCategories: hasMissingWebsiteMenuDestinations } = useGetLinks(
        websiteMenuLinksFields,
        o => o.fields.destination,
    );

    if (hasMissingWebsiteMenuDestinations) {
        return null;
    }

    websiteMenuLinks.forEach((link, index) => {
        const { isCurrent, openInNewWindow, overriddenTitle } = websiteMenuLinksFields[index].fields;
        const title = overriddenTitle || link.title;

        if (title && link.url) {
            websiteMenuOptions.push({
                title,
                openInNewWindow,
                url: link.url,
            });

            if (isCurrent) {
                websiteMenuCurrentOption = title;
            }
        }
    });

    const websiteMenuItems: MappedLink[] = websiteMenuOptions.map(o => ({
        ...o,
        clickableProps: {
            onClick: (e: React.MouseEvent) => {
                e.preventDefault();
                handleWebsiteSelect(o);
            },
        },
    }));

    const isSameOrigin = (href: string) => {
        const u = new URL(href, window.location.href);
        return u.origin === window.location.origin;
    };

    const toRelativeIfSameOrigin = (href: string) => {
        const u = new URL(href, window.location.href);
        return `${u.pathname}${u.search}${u.hash}`;
    };

    const openUrl = (href: string, target: "_self" | "_blank") => {
        if (!href) return;

        if (target === "_blank") {
            window.open(href, "_blank", "noopener,noreferrer");
            return;
        }

        if (history && isSameOrigin(href)) {
            history.push(/^(https?:)?\/\//.test(href) ? toRelativeIfSameOrigin(href) : href);
        } else {
            history ? history.push(href) : (window.location.href = href);
        }
    };

    const handleWebsiteSelect = (option: { title?: string; url?: string; openInNewWindow?: boolean }) => {
        const target: "_self" | "_blank" = option.openInNewWindow ? "_blank" : "_self";
        const title = option.title || "";
        const url = option.url || "";

        const isDifferent = !!url && title !== websiteMenuCurrentOption;

        if (isDifferent && websiteMenuModalConfig.showSwitchModal) {
            setPendingHref(url);
            setPendingTitle(title);
            setPendingTarget(target);
            setIsSwitchModalOpen(true);
        } else {
            openUrl(url, target);
            closeDrawer();
        }
    };

    const confirmSwitch = () => {
        if (pendingHref) openUrl(pendingHref, pendingTarget);
        setIsSwitchModalOpen(false);
        setPendingHref(null);
        setPendingTitle("");
        closeDrawer();
    };

    const showWebsiteMenu = Boolean(websiteMenuOptions.length);
    /* Store Custom Code - End */

    /* Starter Custom Code - End */
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";

    const { links: headerLinkListLinks, hasMissingCategories } = useGetLinks(
        headerLinkListLinkFields,
        o => o.fields.destination,
    );
    if (hasMissingCategories) {
        return null;
    }
    const openDrawer = () => {
        isCompactHeaderFlyout ? setFlyoutDrawerIsOpen({ isOpen: true }) : setNavDrawerIsOpen({ navDrawerIsOpen: true });
        setInitialValues({});
    };

    const closeDrawer = () => {
        if (isCompactHeaderFlyout) {
            setFlyoutDrawerIsOpen({ isOpen: false });
            setTimeout(() => setFlyoutDrawerIsOpen({ isOpen: undefined }), 300);
            return;
        }

        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    const signInPanelClickHandler = (event: React.MouseEvent) => {
        if (theme.signIn?.useOverlay) {
            event.preventDefault();
            setSignInOverlayIsOpen({ isOpen: true });
        }

        closeDrawer();
    };

    const signInPanelKeyPressHandler = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === " " && history && signInUrl?.url) {
            event.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
            } else {
                history.push(signInUrl.url);
            }

            closeDrawer();
        }
    };

    const onSignOutHandler = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    const navigationModeChangeHandler = (navigationMode: "Storefront" | "Vmi") => {
        setCookie(NavigationModeCookieName, navigationMode);
        if (navigationMode === "Vmi") {
            vmiDashboardPageUrl && history.push(vmiDashboardPageUrl);
        } else if (cart?.status === "AlternateCart") {
            removeCart({
                cartId: API_URL_CURRENT_FRAGMENT,
                isAlternateCart: true,
                onSuccess: () => {
                    homePageUrl && history.push(homePageUrl);
                },
            });
        } else {
            homePageUrl && history.push(homePageUrl);
        }
    };

    const currentPageUrl = currentLocation.pathname;
    const isOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;

    /* Starter Custom Code - Start */
    const mainMenuTitle = translate("Main menu");

    /* Store Custom Code - Start */
    const accountPageLinks = useUniquePageLinks(myAccountPageLink?.children) || [];

    const accountMenuItems: MappedLink[] = [
        { ...myAccountPageLink, children: undefined }, // Store Custom Code
        ...(accountPageLinks as any), // Store Custom Code
        {
            title: translate("Sign Out"),
            clickableProps: {
                onClick: onSignOutHandler,
            },
        },
    ];
    /* Store Custom Code - End */

    const showNonVmiLinks = !displayVmiNavigation && (links.length > 0 || (showQuickOrder && quickOrderLink));
    const showVmiLinks = displayVmiNavigation && vmiPageLinks && vmiPageLinks.length > 0;
    /* Starter Custom Code - End */

    return (
        <>
            <Button
                className="menu-trigger-button"
                onClick={openDrawer}
                {...styles.menuTriggerButton}
                data-test-selector="expandMobileMenu"
            >
                <ButtonIcon className="menu-trigger-button-icon" src={Menu} />
                <AccountMessagesCount {...styles.buttonAccountMessagesCountStyles} /* Starter Custom Code */ />
                <VisuallyHidden /* Starter Custom Code */>{mainMenuTitle}</VisuallyHidden>
            </Button>
            <Drawer
                className="drawer"
                draggable
                position="left"
                {...styles.drawer}
                isOpen={isOpen}
                handleClose={closeDrawer}
                contentLabel="menu drawer"
                data-test-selector="drawerSection"
                rootElementSelector={rootElementSelector}
                // Starter Custom Code
                headline={mainMenuTitle}
                hideHeadline
                closeButtonAccessibleText={translate("Close Menu")}
                drawerContentForwardAs="div"
            >
                <StyledWrapper // Starter Custom Code
                    className="drawer-section-wrapper"
                    {...styles.drawerSectionWrapper}
                    // Starter Custom Code
                    aria-label={translate("Primary Menu")}
                >
                    <StyledWrapper {...styles.largeRowsWrapper} /* Store Custom Code */>
                        {userName && !isGuest && !isPunchOutSession ? (
                            <PanelMenu
                                className="panel-menu"
                                currentUrl={currentPageUrl}
                                panelTrigger={
                                    /* Starter Custom Code - Start */
                                    <PanelRow
                                        className="main-row"
                                        hasChildren
                                        {...styles.largeRow}
                                        aria-haspopup="true"
                                    >
                                        <StyledSpan
                                            className="panel-section-wrapper"
                                            {...styles.largePanelSectionWrapper}
                                        >
                                            <Icon className="main-row-icon" {...styles.accountIcon} />
                                            <AccountMessagesCount {...styles.accountMessagesCountStyles} />
                                            <StyledSpan {...styles.largeRowWrapper}>
                                                {/* Store Removed - main-row-label */}
                                                <Typography className="main-row-value" {...styles.largeRowText}>
                                                    {userDisplayName /* Store Custom Code */}
                                                </Typography>
                                            </StyledSpan>
                                        </StyledSpan>
                                    </PanelRow>
                                    /* Starter Custom Code - End */
                                }
                                menuItems={accountMenuItems} // Starter Custom Code
                                maxDepth={3}
                                closeOverlay={closeDrawer}
                                layer={0}
                                parent={{ title: userDisplayName }} // Store Custom Code
                                backTitle={mainMenuTitle} // Starter Custom Code
                                {...styles.panelMenu}
                            />
                        ) : isPunchOutSession ? (
                            <PanelRow
                                className="main-row" // Starter Custom Code
                                {...styles.largeRow} // Starter Custom Code
                                onClick={onSignOutHandler} // Starter Custom Code
                            >
                                {/* Starter Custom Code - Start */}
                                <StyledSpan className="panel-section-wrapper" {...styles.largePanelSectionWrapper}>
                                    <Icon className="main-row-icon" {...styles.accountIcon} />
                                    <StyledSpan {...styles.largeRowWrapper}>
                                        {/* Store Removed - main-row-label */}
                                        <Typography className="main-row-value" {...styles.largeRowText}>
                                            {translate("Cancel PunchOut")}
                                        </Typography>
                                    </StyledSpan>
                                </StyledSpan>
                                {/* Starter Custom Code - End */}
                            </PanelRow>
                        ) : (
                            <PanelRow
                                className="main-row" // Starter Custom Code
                                {...styles.largeRow} // Starter Custom Code
                                isCurrent={currentPageUrl === signInUrl?.url}
                                onClick={signInPanelClickHandler}
                                onKeyUp={signInPanelKeyPressHandler}
                                href={signInUrl?.url}
                                as="a" // Starter Custom Code
                            >
                                {/* Starter Custom Code - Start */}
                                <StyledSpan className="panel-section-wrapper" {...styles.largePanelSectionWrapper}>
                                    <Icon className="main-row-icon" {...styles.accountIcon} />
                                    <StyledSpan {...styles.largeRowWrapper}>
                                        {/* Store Removed - main-row-label */}
                                        <Typography className="main-row-value" {...styles.largeRowText}>
                                            {translate("Login/Register") /* Store Custom Code */}
                                        </Typography>
                                    </StyledSpan>
                                </StyledSpan>
                                {/* Starter Custom Code - End */}
                            </PanelRow>
                        )}
                        {/* covers MainNavigation functionality */}
                        {/* Starter Moved - !displayVmiNavigation - down */}
                        {/* Starter Moved - !displayVmiNavigation && showQuickOrder - down */}
                        {/* Starter Moved - displayVmiNavigation && - down */}
                        {/* Starter Moved - headerLinkListLinks/drawerSectionWrapper - down */}
                        {/* Starter Moved - StyledWrapper/currencySelectorWrapper - down */}
                        {/* Starter Moved - StyledWrapper/languageSelectorWrapper - down */}
                        {showCustomerMenuItem && /* Store Custom Code */ isB2BCustomer && (
                            <PanelMenu
                                className="panel-menu"
                                /* Starter Custom Code - Start */
                                {...styles.contentPanelMenu}
                                as="div"
                                backTitle={mainMenuTitle}
                                panelTrigger={
                                    <PanelRow
                                        hasChildren
                                        className="main-row"
                                        {...styles.largeRow}
                                        aria-haspopup="true"
                                    >
                                        <StyledSpan
                                            className="panel-section-wrapper"
                                            {...styles.largePanelSectionWrapper}
                                        >
                                            <Icon className="main-row-icon" {...styles.fulfillmentIcon} />
                                            <StyledSpan {...styles.largeRowWrapper}>
                                                {/* Store Removed - main-row-label */}
                                                <Typography className="main-row-value" {...styles.largeRowText}>
                                                    {translate("Fulfillment Method") /* Store Custom Code */}
                                                </Typography>
                                            </StyledSpan>
                                        </StyledSpan>
                                    </PanelRow>
                                }
                                /* Starter Custom Code - End */
                                layer={0}
                                closeOverlay={closeDrawer}
                            >
                                {isPunchOutSession ? (
                                    <PanelRow
                                        tabIndex={-1}
                                        className="change-customer-row"
                                        {...styles.changeCustomerRow}
                                    >
                                        {createWidgetElement("Header/AddressDrawerPunchOutCustomer", {
                                            fields: {},
                                        })}
                                    </PanelRow>
                                ) : (
                                    <PanelRow
                                        tabIndex={-1}
                                        className="change-customer-row"
                                        {...styles.changeCustomerRow}
                                    >
                                        <GridContainer
                                            className="change-customer-row-container"
                                            {...styles.changeCustomerRowContainer}
                                        >
                                            <GridItem
                                                className="fulfillment-method-grid-item"
                                                {...styles.fulfillmentMethodGridItem}
                                            >
                                                {createWidgetElement("Header/AddressDrawerFulfillmentMethodSelector", {
                                                    fields: {},
                                                })}
                                            </GridItem>
                                            {showAddressesSelector /* Starter Custom Code */ && (
                                                <GridItem className="addresses-grid-item" {...styles.addressesGridItem}>
                                                    {createWidgetElement("Header/AddressDrawerSelectCustomer", {
                                                        fields: {},
                                                    })}
                                                </GridItem>
                                            )}
                                            {fulfillmentMethod ===
                                                FulfillmentMethod.PickUp /* Starter Custom Code */ && (
                                                <GridItem
                                                    className="pick-up-address-grid-item"
                                                    {...styles.pickUpAddressGridItem}
                                                >
                                                    {createWidgetElement("Header/AddressDrawerPickUpLocationSelector", {
                                                        fields: {},
                                                    })}
                                                </GridItem>
                                            )}
                                        </GridContainer>
                                        <FormActions fullWidth /* Starter Custom Code */>
                                            {createWidgetElement("Header/AddressDrawerApplyButton", { fields: {} })}
                                        </FormActions>
                                    </PanelRow>
                                )}
                            </PanelMenu>
                        )}
                    </StyledWrapper /* Store Custom Code */>
                    {/* Starter Custom Code - Start */}
                    {(showNonVmiLinks || showVmiLinks) && (
                        <StyledWrapper {...styles.mainNavigationWrapper}>
                            {/* covers MainNavigation functionality */}
                            {!displayVmiNavigation &&
                                links.map((link, index) => {
                                    if (
                                        !!link.childrenType &&
                                        link.children &&
                                        link.children.filter(o => !o.excludeFromNavigation).length > 0
                                    ) {
                                        const href =
                                            allowOpenParentLinks && link.url && link.url !== currentPageUrl
                                                ? link.url
                                                : undefined;

                                        return (
                                            <PanelMenu
                                                className="panel-menu"
                                                key={index}
                                                currentUrl={currentPageUrl}
                                                closeOverlay={closeDrawer}
                                                panelTrigger={
                                                    <PanelRow
                                                        className="main-row"
                                                        href={href}
                                                        isCurrent={link.url === currentPageUrl}
                                                        hasChildren={true}
                                                        allowOpenParentLinks={allowOpenParentLinks}
                                                        {...styles.mainNavigationRow}
                                                    >
                                                        <Typography
                                                            className="main-row-text"
                                                            {...styles.mainNavigationRowTypography}
                                                        >
                                                            {link.title}
                                                        </Typography>
                                                    </PanelRow>
                                                }
                                                menuItems={link.children}
                                                maxDepth={link.maxDepth || 3}
                                                layer={0}
                                                allowOpenParentLinks={allowOpenParentLinks}
                                                {...styles.panelMenu}
                                                parent={link}
                                                backTitle={mainMenuTitle}
                                                as="div"
                                            />
                                        );
                                    }
                                    return (
                                        <PanelRow
                                            key={index}
                                            href={link.url}
                                            target={link.openInNewWindow ? "_blank" : "_self"}
                                            className="main-row"
                                            onClick={closeDrawer}
                                            {...styles.mainNavigationRow}
                                            isCurrent={currentPageUrl === link.url}
                                        >
                                            <Typography
                                                className="main-row-text"
                                                {...styles.mainNavigationRowTypography}
                                            >
                                                {link.title}
                                            </Typography>
                                        </PanelRow>
                                    );
                                })}
                            {!displayVmiNavigation && showQuickOrder && quickOrderLink && (
                                <PanelRow
                                    className="main-row"
                                    isCurrent={currentPageUrl === quickOrderLink.url}
                                    onClick={closeDrawer}
                                    href={quickOrderLink.url}
                                    {...styles.mainNavigationRow}
                                >
                                    <Typography className="main-row-text" {...styles.mainNavigationRowTypography}>
                                        {quickOrderLink.title}
                                    </Typography>
                                </PanelRow>
                            )}
                            {displayVmiNavigation &&
                                vmiPageLinks &&
                                vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <PanelRow
                                                className="main-row"
                                                key={link.id}
                                                isCurrent={currentPageUrl === link.url}
                                                onClick={closeDrawer}
                                                href={link.url}
                                                {...styles.mainNavigationRow}
                                            >
                                                <Typography
                                                    className="main-row-text"
                                                    {...styles.mainNavigationRowTypography}
                                                >
                                                    {link.title}
                                                </Typography>
                                            </PanelRow>
                                        ),
                                )}
                        </StyledWrapper>
                    )}
                    {/* Starter Custom Code - End */}
                </StyledWrapper>
                {/* Starter Custom Code - Start */}
                {headerLinkListLinks.length > 0 && (
                    <StyledWrapper
                        className="drawer-secondary-section-wrapper"
                        {...styles.drawerSecondarySectionWrapper}
                    >
                        {headerLinkListLinks.map((link, index) => {
                            const linkFields = headerLinkListLinkFields[index].fields;

                            return (
                                <PanelRow
                                    className="secondary-row"
                                    key={link.title + String(index)}
                                    {...(styles.logoLinks && omitSingle(styles.logoLinks, "typographyProps"))}
                                    isCurrent={currentPageUrl === link.url}
                                    onClick={closeDrawer}
                                    onKeyPress={(event: React.KeyboardEvent<HTMLAnchorElement>) => {
                                        if (event.key === " " && history && link?.url) {
                                            event.preventDefault();
                                            closeDrawer();
                                            history.push(link.url);
                                        }
                                    }}
                                    href={link.url}
                                    target={headerLinkListLinkFields[index].fields.openInNewWindow ? "_blank" : "_self"}
                                >
                                    <StyledSpan {...styles.panelSectionWrapper}>
                                        <Icon
                                            className="secondary-row-icon"
                                            {...getIconProps(headerLinkListIcons[linkFields.icon]?.src)}
                                        />
                                        <Typography
                                            className="secondary-row-text"
                                            {...styles.logoLinks?.typographyProps}
                                        >
                                            {linkFields.overriddenTitle || link.title}
                                        </Typography>
                                    </StyledSpan>
                                </PanelRow>
                            );
                        })}
                    </StyledWrapper>
                )}
                {/* Store Custom Code - Start */}
                {showVisualizerMenu && (
                    <StyledWrapper
                        className="drawer-secondary-section-wrapper"
                        {...styles.drawerSecondarySectionWrapper}
                    >
                        <PanelRow
                            className="secondary-row"
                            {...(styles.logoLinks && omitSingle(styles.logoLinks, "typographyProps"))}
                            onClick={() => {
                                closeDrawer();
                                visualizerMenuOnClick();
                            }}
                        >
                            <StyledSpan {...styles.panelSectionWrapper}>
                                {showVisualizerIcon && (
                                    <Icon className="secondary-row-icon" {...getIconProps(visualizerMenuIcon.src)} />
                                )}
                                <Typography className="secondary-row-text" {...styles.logoLinks?.typographyProps}>
                                    {visualizerMenuTitle}
                                </Typography>
                            </StyledSpan>
                        </PanelRow>
                    </StyledWrapper>
                )}
                {/* Store Custom Code - End */}
                {(showCurrencyMenu ||
                    showLanguageMenu ||
                    showSettingsMenu ||
                    showWebsiteMenu) /* Store Custom Code */ && (
                    <StyledWrapper
                        className="drawer-secondary-section-wrapper"
                        {...styles.drawerSecondarySectionWrapper}
                    >
                        {showCurrencyMenu && (
                            <StyledWrapper className="currency-selector-wrapper" {...styles.currencySelectorWrapper}>
                                <SelectorMenu
                                    options={currencies?.map(c => {
                                        return {
                                            title: c.currencyCode.toUpperCase(),
                                            clickableProps: {
                                                onClick: () => {
                                                    setCurrency({ currencyId: c.id });
                                                    closeDrawer();
                                                },
                                            },
                                        };
                                    })}
                                    closeModal={closeDrawer}
                                    currentOption={currencies?.find(c => c.id === currentCurrencyId)?.currencyCode}
                                    currentOptionIcon={
                                        showCurrencyIcon ? (
                                            <Typography {...styles.currencySymbol}>{currentCurrencySymbol}</Typography>
                                        ) : undefined
                                    }
                                    backTitle={mainMenuTitle}
                                    mainTitle={translate("Select Currency")}
                                    visuallyHiddenTitle={translate("Select Currency")}
                                />
                            </StyledWrapper>
                        )}
                        {showLanguageMenu && (
                            <StyledWrapper className="language-selector-wrapper" {...styles.languageSelectorWrapper}>
                                <SelectorMenu
                                    dataTestSelector="mobileLanguageSelector"
                                    options={languages?.map(l => {
                                        return {
                                            title: l.description,
                                            clickableProps: {
                                                onClick: () => {
                                                    setLanguage({ languageId: l.id });
                                                    closeDrawer();
                                                },
                                            },
                                        };
                                    })}
                                    currentOption={currentLanguage?.description}
                                    closeModal={closeDrawer}
                                    currentOptionIcon={
                                        showLanguageIcon ? (
                                            currentLanguage?.imageFilePath ? (
                                                <LogoImageWrapper>
                                                    <LogoImage
                                                        className="language-image"
                                                        src={currentLanguage.imageFilePath}
                                                        alt={currentLanguage.languageCode}
                                                    />
                                                </LogoImageWrapper>
                                            ) : (
                                                <Icon className="secondary-row-icon" {...styles.languageIcon} />
                                            )
                                        ) : undefined
                                    }
                                    backTitle={mainMenuTitle}
                                    mainTitle={translate("Select Language")}
                                    visuallyHiddenTitle={translate("Select Language")}
                                />
                            </StyledWrapper>
                        )}
                        {showSettingsMenu && (displayModeSwitch || showInventoryToggle || showPricingToggle) && (
                            <PanelMenu
                                className="panel-menu"
                                {...styles.contentPanelMenu}
                                panelTrigger={
                                    <PanelRow
                                        className="secondary-row"
                                        {...(styles.logoLinks && omitSingle(styles.logoLinks, "typographyProps"))}
                                        hasChildren
                                    >
                                        <StyledSpan {...styles.panelSectionWrapper}>
                                            {showSettingsIcon && (
                                                <Icon className="secondary-row-icon" {...getIconProps(SettingsLine)} />
                                            )}
                                            <Typography
                                                className="secondary-row-text"
                                                {...styles.logoLinks?.typographyProps}
                                            >
                                                {translate("Navigation Settings")}
                                            </Typography>
                                        </StyledSpan>
                                    </PanelRow>
                                }
                                layer={0}
                                closeOverlay={closeDrawer}
                                backTitle={mainMenuTitle}
                            >
                                <PanelRow tabIndex={-1} className="settings-row" {...styles.settingsRow}>
                                    {displayModeSwitch && (
                                        <StyledWrapper {...styles.settingWrapper}>
                                            <NavigationModeMenu onChange={closeDrawer} />
                                        </StyledWrapper>
                                    )}
                                    {showInventoryToggle && (
                                        <StyledWrapper {...styles.settingWrapper}>
                                            <ShowInventoryToggle extendedStyles={styles.showInventoryToggle} />
                                        </StyledWrapper>
                                    )}
                                    {showPricingToggle && (
                                        <StyledWrapper {...styles.settingWrapper}>
                                            <ShowPricingToggle extendedStyles={styles.showPricingToggle} />
                                        </StyledWrapper>
                                    )}
                                </PanelRow>
                            </PanelMenu>
                        )}
                        {/* Store Custom Code - Start */}
                        {showWebsiteMenu && (
                            <StyledWrapper {...styles.websiteSelectorWrapper}>
                                <SelectorMenu
                                    options={websiteMenuItems}
                                    currentOption={websiteMenuCurrentOption || translate("Select Website")}
                                    currentOptionIcon={<Icon className="secondary-row-icon" {...styles.websiteIcon} />}
                                    closeModal={closeDrawer}
                                    backTitle={mainMenuTitle}
                                    mainTitle={translate("Select Website")}
                                    visuallyHiddenTitle={translate("Select Website")}
                                    className="website-selector"
                                />
                            </StyledWrapper>
                        )}
                        {/* Store Custom Code - End */}
                    </StyledWrapper>
                )}
                {/* Starter Custom Code - End */}
                {/* Store Custom Code - Start */}
                <TwoButtonModal
                    modalIsOpen={isSwitchModalOpen}
                    headlineText={websiteMenuModalConfig.modalHeadline.replace("{0}", pendingTitle)}
                    messageText={websiteMenuModalConfig.modalBody.replace("{0}", pendingTitle)}
                    cancelButtonText={websiteMenuModalConfig.modalCancelLabel}
                    submitButtonText={websiteMenuModalConfig.modalCtaLabel}
                    onCancel={() => {
                        setIsSwitchModalOpen(false);
                        setPendingHref(null);
                        setPendingTitle("");
                    }}
                    onSubmit={confirmSwitch}
                />
                {/* Store Custom Code - End */}
            </Drawer>
        </>
    );
};

/* Starter Custom Code - Start */
const LogoImageWrapper = styled.span`
    ${iconOffsetStyles(iconDefault.offset, iconDefault.spacing)}
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${iconDefault.size};
    height: ${iconDefault.size};
`;

const LogoImage = styled.img`
    width: ${languageIconSize};
    height: ${languageIconSize};
    background: currentColor;
    border-radius: 50%;
    object-fit: cover;
    overflow: hidden;
`;
/* Starter Custom Code - End */

interface SelectorMenuProps {
    options?: MappedLink[];
    closeModal?: () => void;
    currentOption?: string;
    currentOptionIcon?: React.ReactNode;
    dataTestSelector?: string;
    // Starter Custom Code
    backTitle?: string;
    mainTitle: string;
    visuallyHiddenTitle?: string;
    // Store Custom Code
    className?: string;
}

const SelectorMenu: React.FC<SelectorMenuProps> = ({
    options,
    closeModal,
    currentOption,
    currentOptionIcon,
    dataTestSelector,
    // Starter Custom Code
    backTitle,
    mainTitle,
    visuallyHiddenTitle,
    // Store Custom Code
    className,
}) => {
    if (!options || options.length <= 1) {
        return null;
    }

    const trigger = (
        <PanelRow
            hasChildren
            className={`secondary-row${className ? ` ${className}` : ""}`} // Store Custom Code
            {...styles.logoLinks}
        >
            {visuallyHiddenTitle ? <VisuallyHidden>{visuallyHiddenTitle}</VisuallyHidden> : null}
            <StyledSpan className="panel-section-wrapper" {...styles.panelSectionWrapper}>
                {currentOptionIcon}
                <Typography
                    className="secondary-row-text" // Starter Custom Code
                    data-test-selector={`${dataTestSelector}_currentOption`}
                    {...styles.logoLinks?.typographyProps}
                >
                    {currentOption}
                </Typography>
            </StyledSpan>
        </PanelRow>
    );

    return (
        <PanelMenu
            className="panel-menu"
            currentUrl={currentOption}
            data-test-selector={dataTestSelector}
            closeOverlay={closeModal}
            panelTrigger={trigger}
            menuItems={options}
            maxDepth={1}
            layer={0}
            {...styles.panelMenu}
            // Starter Custom Code
            backTitle={backTitle}
            parent={{ title: mainTitle }}
            as="div"
        />
    );
};

function findVisibilityState(data: any): string | undefined {
    for (const key in data) {
        if (data[key].type === "Common/HeaderSignIn") {
            return data[key].generalFields.visibilityState;
        }
    }
    return undefined;
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(NavigationDrawer)));
